/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CardHeader from './children/CardHeader.js';
import CardBody from './children/CardBody.js';
import CardImage from './children/CardImage.js';
import CardLabeledRows from './children/CardLabeledRows.js';
import CardStackedLabeledRows from './children/CardStackedLabeledRows.js';
import CardLabeledItem from './children/CardLabeledItem.js';

var _excluded = ["children", "className", "callOut", "fadeIn"];
var Card = function Card(_ref) {
  var children = _ref.children,
    className = _ref.className,
    callOut = _ref.callOut,
    fadeIn = _ref.fadeIn,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: classnames({
      'cpc--card': true,
      'cpc--card--call-out': callOut,
      'cpc--card--fade-in': fadeIn
    }, className)
  }), children);
};
Card.propTypes = {
  /**
   * Whether or not the card should be called out. If this value is true the card will render with a gray 90 background and white.
   */
  callOut: PropTypes.bool,
  /**
   * Whether or not the card should animate in on render. If true, the card will vertically tranform and change opacity on render.
   */
  fadeIn: PropTypes.bool,
  /**
   * Any component's, elements, or strings to be rendered inside of the card component.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * A class name that will be applied to the card component.
   */
  className: PropTypes.string
};

// TODO: Remove when bumping to V2.
Card.header = CardHeader;
Card.body = CardBody;
Card.image = CardImage;
Card.labeledRows = CardLabeledRows;
Card.stackedLabeledRows = CardStackedLabeledRows;
Card.labeledItem = CardLabeledItem;
Card.Header = CardHeader;
Card.Body = CardBody;
var Card$1 = Card;

export { Card$1 as default };
